module.exports = __webpack_public_path__ + "media/img/help_center/Student_Academic_Profile_06-8ca9cca5b73ec54ba033cf5e7f6321d5.jpg";